import * as React from 'react'
import type { SVGProps } from 'react'
const SvgDiscord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.6516 5.417a.056.056 0 0 0-.0289-.026 18.15 18.15 0 0 0-4.4778-1.3898.068.068 0 0 0-.0718.0339 12.5 12.5 0 0 0-.5578 1.1454 16.76 16.76 0 0 0-5.0285 0A11.6 11.6 0 0 0 8.92 4.035a.07.07 0 0 0-.0729-.034A18.07 18.07 0 0 0 4.3694 5.39a.064.064 0 0 0-.0299.025C1.488 9.6751.7078 13.8296 1.091 17.9323a.076.076 0 0 0 .029.0519 18.25 18.25 0 0 0 5.4934 2.7756.07.07 0 0 0 .0769-.0249 13 13 0 0 0 1.1234-1.8278.07.07 0 0 0-.0134-.0812.07.07 0 0 0-.0245-.0156 12.03 12.03 0 0 1-1.7161-.8181.071.071 0 0 1-.007-.1168 8 8 0 0 0 .3412-.2664.068.068 0 0 1 .0709-.0099c3.6008 1.6432 7.4979 1.6432 11.0558 0a.068.068 0 0 1 .0728.0089c.1098.0898.2255.1816.3412.2674a.07.07 0 0 1 .028.0599.07.07 0 0 1-.034.0569 11.4 11.4 0 0 1-1.717.8181.069.069 0 0 0-.04.0402.07.07 0 0 0 .003.0566 14.6 14.6 0 0 0 1.1225 1.8258.069.069 0 0 0 .0768.0269 18.19 18.19 0 0 0 5.5025-2.7756.07.07 0 0 0 .0289-.0499c.459-4.7442-.7692-8.8648-3.2536-12.5175M8.3504 15.434c-1.0836 0-1.9765-.9947-1.9765-2.216 0-1.2222.876-2.2169 1.9765-2.2169 1.1105 0 1.9954 1.0037 1.9775 2.2169 0 1.2213-.876 2.216-1.9775 2.216m7.3103 0c-1.0835 0-1.9775-.9947-1.9775-2.216 0-1.2222.876-2.2169 1.9775-2.2169 1.1105 0 1.9955 1.0037 1.9775 2.2169 0 1.2213-.868 2.216-1.9775 2.216"
    />
  </svg>
)
export default SvgDiscord
